var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"dd-m-modal dd-m-modal--quiz",attrs:{"name":"modal-quiz-offline"}},[(_vm.quiz)?_c('quiz-content-offline',{attrs:{"data":_vm.quiz}}):_vm._e()],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7bf0db6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/site/js/components/custom-modals/modal-quiz-offline.vue
// module id = 467
// module chunks = 2